export type OpenAIModel = (typeof OPENAI_MODELS)[number];

export const OPENAI_MODELS = [
  "gpt-5.6-terra",
  "gpt-5.4",
  "gpt-5.4-mini",
  "gpt-5.4-nano",
  "gpt-5.2",
  "gpt-4.1",
  "gpt-4.1-mini",
] as const;

export function isOpenAIModel(model: string): model is OpenAIModel {
  return OPENAI_MODELS.includes(model as OpenAIModel);
}

export interface OpenAIProviderParams {
  /** Modify the likelihood of specified tokens appearing in the completion */
  logitBias?: Record<number, number>;
  /** Return the log probabilities of the tokens */
  logprobs?: boolean | number;
  /** Whether to enable parallel function calling during tool use */
  parallelToolCalls?: boolean;
  /** Whether to use structured outputs */
  structuredOutputs?: boolean;
  /** Whether to use legacy function calling */
  useLegacyFunctionCalling?: boolean;
  /** A unique identifier representing your end-user */
  user?: string;
  /** Automatically download images and pass the image as data to the model */
  downloadImages?: boolean;
  /** Simulates streaming by using a normal generate call */
  simulateStreaming?: boolean;
  /** Reasoning effort for reasoning models */
  reasoningEffort?: "low" | "medium" | "high";
}
